/**
 * @link https://span.studio
 * @copyright Copyright (c) Span Studio LLC
 * @license https://github.com/Span-Studio/sta100-craft5/blob/main/LICENSE.md
 * 
 * Text Editor.
 * WYSIWYG editor for front-end entry forms. 
 * Wrapper around Quilljs. 
 * 
 * @author John Pobojewski <https://john.pobojewski.com
 * @link https://quilljs.com/
 */

import Quill from 'quill';
import "quill/dist/quill.core.css";

class TextEditor {
	init($selector, $textarea){
		console.log("TextEditor.js: init()");
		const quill = new Quill($selector, {
			modules: {
				toolbar: [
					['bold', 'italic', 'link']
				]
			},
			theme: 'snow',
		});

		const textarea = document.querySelector($textarea);

		quill.on('text-change', (delta, oldDelta, source) => {
		  textarea.value = quill.getSemanticHTML();
		});
	}
}

export default new TextEditor();